export default __webpack_public_path__ + "static/media/ww8.0790a275.jpg";